import React from 'react';
import CertificateDescription from '../../components/jsx/profile/CertificatesPage/Description/CertificatesDescription';
import CertificateImageComponent from '../../components/jsx/profile/CertificatesPage/CertificateImage/CertificateImageComponent';
import StudentProfile from '../../components/jsx/profile/CertificatesPage/studentProfile/StudentProfile';
import NoCertificateAvailable from '../../components/jsx/profile/CertificatesPage/NoCertificateAvailable/NoCertificateAvailable';

const CertificatePage = () => {
  const hasCertificates = false;

  return (
    <div className="">
      <div className='grid grid-cols-12 gap-6'>
        {/* Main content area - certificates or no certificate message */}
        <div className='col-span-12 lg:col-span-9'>
          {hasCertificates ? (
            // Certificate content when available
            <>
              <CertificateDescription />
              <CertificateImageComponent /> 
            </>
          ) : (
            // No certificates message
            <NoCertificateAvailable />
          )}
        </div>
        
        {/* Student profile sidebar - always visible */}
        <div className='col-span-12 lg:col-span-3'>
          <StudentProfile />
        </div>
      </div>
    </div>
  );
};

export default CertificatePage;